export const gcpTemplatePaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/instance-templates`,
  detail: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/instance-templates/${encodeURIComponent(name)}`,
  create: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/instance-templates`,
  remove: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/instance-templates/${encodeURIComponent(name)}`,
};
